import { useI18n } from "../../../hooks"
import { StringMap } from "../../../types/common"

export const useTranslations = (defaults = defaultTranslations): Translations => {
  const { translations: t } = useI18n("translation")
  const translations = (t.userSettingsView || {}) as StringMap
  const {
    pageTitle = defaults.pageTitle,
    deleteAccountHeader = defaults.deleteAccountHeader,
    deleteAccountDescription = defaults.deleteAccountDescription,
    deleteAccountInfoText = defaults.deleteAccountInfoText,
    deleteAccountButtonLabel = defaults.deleteAccountButtonLabel,
    deleteAccountConfirmationDialogTitle = defaults.deleteAccountConfirmationDialogTitle,
    deleteAccountConfirmationDialogAlertText = defaults.deleteAccountConfirmationDialogAlertText,
    deleteAccountConfirmationDialogText = defaults.deleteAccountConfirmationDialogText,
    deleteAccountExtraConfirmationTextLabel = defaults.deleteAccountExtraConfirmationTextLabel,
    deleteAccountConfirmationPasswordLabel = defaults.deleteAccountConfirmationPasswordLabel,
    deleteErrorMessage = defaults.deleteErrorMessage,
    deleteAccountDialogUserInfoText = defaults.deleteAccountDialogUserInfoText,
    usernameText = defaults.usernameText,
    emailText = defaults.emailText,
    deleteSuccessDialogTitle = defaults.deleteSuccessDialogTitle,
    deleteSuccessDialogText = defaults.deleteSuccessDialogText,
    deleteSuccessDialogGreetingText = defaults.deleteSuccessDialogGreetingText,
    deleteSuccessDialogCloseButtonLabel = defaults.deleteSuccessDialogCloseButtonLabel,
  } = translations

  return {
    pageTitle,
    deleteAccountHeader,
    deleteAccountDescription,
    deleteAccountInfoText,
    deleteAccountButtonLabel,
    deleteAccountConfirmationDialogTitle,
    deleteAccountConfirmationDialogAlertText,
    deleteAccountConfirmationDialogText,
    deleteAccountExtraConfirmationTextLabel,
    deleteAccountConfirmationPasswordLabel,
    deleteErrorMessage,
    deleteAccountDialogUserInfoText,
    usernameText,
    emailText,
    deleteSuccessDialogTitle,
    deleteSuccessDialogText,
    deleteSuccessDialogGreetingText,
    deleteSuccessDialogCloseButtonLabel,
  }
}

const defaultTranslations = {
  pageTitle: "General settings",
  deleteAccountHeader: "Delete my account",
  deleteAccountDescription: "You cannot undo this action. Please be certain.",
  deleteAccountInfoText:
    "Before you proceed, please make sure that you are not an organisation owner. If you are, you need to either transfer the ownership to another user or delete the organisation.",
  deleteAccountButtonLabel: "Delete account",
  deleteAccountConfirmationDialogTitle: "Are you sure?",
  deleteAccountConfirmationDialogAlertText: "Before proceeding, please  read the following text carefully.",
  deleteAccountConfirmationDialogText:
    "This action will result in the permanent deletion of the user, along with its projects, tasks, to-dos, calendar events, and all other associated data.",
  deleteAccountExtraConfirmationTextLabel: "Please enter this text in the box below",
  deleteAccountConfirmationPasswordLabel: "Please enter your password",
  deleteErrorMessage: "An error occurred while deleting the account!",

  deleteAccountDialogUserInfoText: "You are deleting the account associated with the following details",
  usernameText: "User name",
  emailText: "Email",

  deleteSuccessDialogTitle: "Account deletion successful!",
  deleteSuccessDialogText:
    "We have now permanently deleted your user account, along with its projects, tasks, to-dos, calendar events, and all other associated data.",
  deleteSuccessDialogGreetingText: "Thank you for using starbrix. We hope to see you again soon!",
  deleteSuccessDialogCloseButtonLabel: "Close",
}

type Translations = typeof defaultTranslations
